import { analytics } from '../service';

export function trackInviteLinkClicked(isAuthenticated: boolean): void {
  analytics.captureEvent('Duos Invite Link Clicked', {
    is_authenticated: isAuthenticated,
  });
}

export function trackInviteModalOpened(inviterDisplayName: string): void {
  analytics.captureEvent('Duos Invite Modal Opened', {
    inviter_display_name: inviterDisplayName,
  });
}

export function trackInviteAccepted(
  inviterDisplayName: string,
  alreadyDuos: boolean,
): void {
  analytics.captureEvent('Duos Invite Accepted', {
    inviter_display_name: inviterDisplayName,
    already_duos: alreadyDuos,
  });
}

export function trackInviteShareModalOpened(): void {
  analytics.captureEvent('Duos Invite Share Modal Opened', {});
}

export function trackInviteLinkCopied(): void {
  analytics.captureEvent('Duos Invite Link Copied', {});
}

export function trackInviteLinkShared(): void {
  analytics.captureEvent('Duos Invite Link Shared', {});
}

export function trackInviteLinkGenerated(isRegenerate: boolean): void {
  analytics.captureEvent('Duos Invite Link Generated', {
    is_regenerate: isRegenerate,
  });
}
